import {Component, Injector, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

import {Offer, ResponsePrecontractInfo, StepData} from 'models';
import {combineLatest, of} from 'rxjs';
import {catchError, debounceTime, first} from 'rxjs/operators';
import {SimTypeEnum} from '../../../../../../app-shared/models/steps/step-sim.interface';
import {ProcessStepBaseComponent} from '../../_core/process-step-base.component';

@Component({
  selector: 'sb-step-contact',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent extends ProcessStepBaseComponent implements OnInit {
  public SIM_TYPES = SimTypeEnum;
  public simType: SimTypeEnum;
  public precontractUrl = '';

  constructor(injector: Injector) {
    super(injector);
  }

  private managePreContract() {
    this.precontractUrl = this.environmentService.getPrecontractDefaultUrl();

    this.subscriptions.add(
      this.appStoreFacadeService.entity.offer$
        .pipe(first(Boolean))
        .subscribe((offer: Offer) => {
          this.execService
            .getPrecontractInfo(offer.productId || offer.ropz)
            .pipe(catchError(err => {
              return of(null);
            })).subscribe((resp: ResponsePrecontractInfo) => {
            this.precontractUrl = (resp && (resp.filenameLink || resp.link)) ||
              this.environmentService.getPrecontractDefaultUrl();
          });
        })
    );
  }

  ngOnInit() {
    // super.shouldShowBackButton();
    super.isStickyNavigation();
    super.setFormGroup(this.formsService.generateStepContactsForm());
    super.setFormStoreDataFunction(this.appStoreFacadeService.step.storeStepContactsValue);
    this.manageSimType();
    this.getFormDataAndValidation();
    this.managePreContract();
  }

  goToNextStep() {
    this.formGroup.get('customerContacts.confirmEmail').updateValueAndValidity();
    return super.goToNextStep();
  }

  private manageSimType(): void {
    this.subscriptions.add(
      combineLatest(
        [ this.appStoreFacadeService.entity.simType$ ]
      ).subscribe(([simTypeEntity]) => {
        const simType = simTypeEntity && simTypeEntity.value && simTypeEntity.value.type;
        if (!simType) {
          return;
        }
        this.simType = simType;
        if (this.simType === SimTypeEnum.IdleSim) {
          this.handleUniqueConsents();
        }
      })
    );
  }

  private getFormDataAndValidation() {
    this.subscriptions.add(
      this.appStoreFacadeService.step.contacts$
        .subscribe((stepData: StepData) => {
          super.setFormGroupStepData(stepData);
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.step.contactsValue$
        .pipe(debounceTime(150), first(Boolean))
        .subscribe(() => {
          this.sendAnalyticsData();
        })
    );
  }

  private handleUniqueConsents() {
    const generalConsentsFormGroup = this.formGroup.get('generalConsents') as FormGroup;
    const generalServiceField = generalConsentsFormGroup.get('generalServiceConditionsAccepted');

    generalConsentsFormGroup.patchValue({
      precontractConditionsAccepted: generalServiceField.value
    });

    this.subscriptions.add(
      generalServiceField.valueChanges.subscribe((value) => {
        generalConsentsFormGroup.patchValue({
          precontractConditionsAccepted: value
        });
      })
    );
  }

  public get formGroupInvalid() {
    return this.formGroup.invalid ||
      (this.simType === SimTypeEnum.IdleSim && !this.formGroup.get('generalConsents.precontractConditionsAccepted').value);
  }

}
